<template><!-- svgo-optimised -->
<svg class="icon icon__play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 5.14v14l11-7z"/></svg></template>